/**
 * Get the URL parameters.
 * Inspired by: https://css-tricks.com/snippets/javascript/get-url-variables/
 * @returns {.window.sonicGlobal.queryParams|@exp;getQueryParams@pro;sonicGlobal@pro;queryParams} Object of URL parameters.
 */
const getQueryParams = function() {
	var sonicGlobal = window.sonicGlobal || {};
	if ('undefined' === typeof sonicGlobal.queryParams) {
		let queryParams = {},
			query = window.location.search.substring(1),
			vars = query.split("&"),
			varCount = vars.length;

		for (let i = 0; i < varCount; i++) {
			let pair = vars[i].split("=");
			if ('undefined' === typeof queryParams[pair[0]]) {
				queryParams[pair[0]] = decodeURIComponent(pair[1]);
			} else if ('string' === typeof queryParams[pair[0]]) {
				queryParams[pair[0]] = [
					queryParams[pair[0]],
					decodeURIComponent(pair[1])
				];
			} else {
				queryParams[pair[0]].push(decodeURIComponent(pair[1]));
			}
		}
		sonicGlobal.queryParams = queryParams;
	}
	return sonicGlobal.queryParams;
};

export default getQueryParams;
